module.exports = __webpack_public_path__ + "img/slim.312b6574.png";